import type { AppletLayoutProps } from '../applets';

import AppShellHeader from '@cartwhl/ui/layout/AppShellHeader';

export default function DefaultAppletLayout({
  children,
  title: _title,
}: AppletLayoutProps) {
  return (
    <div className="bg-primary flex h-dvh max-h-dvh min-h-0 flex-col overflow-hidden">
      <AppShellHeader />
      <main className="flex min-h-0 flex-1 flex-col overflow-y-auto">{children}</main>
    </div>
  );
}
